const ErrorPage = () => <div>Errors happened!</div>

export default ErrorPage
